function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { AvGroup } from "availity-reactstrap-validation";
import BlankSpace from "../../styled/BlankSpace";
import TmOverlayFieldDeleteModal from "./TmOverlayFieldDeleteModal";
import styled from "styled-components";
import { LinkFontAwesome } from "../../general/LinkFontAwesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons";
const StyledCloseWrapper = styled.div`
  line-height: 1.6rem;
  padding: .3rem 0;
`;
const StyledFontAwesomeIcon = styled(LinkFontAwesome)`
  font-size: 1.6rem;
`;

class TmClearNestedField extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(BlankSpace, {
        rem: 1.9
      }), /*#__PURE__*/React.createElement(TmOverlayFieldDeleteModal, {
        onClear: this.props.onClear,
        trigger: this.props.trigger || /*#__PURE__*/React.createElement(StyledCloseWrapper, null, /*#__PURE__*/React.createElement(StyledFontAwesomeIcon, {
          className: 'text-danger',
          icon: faTimesCircle,
          cypress: 'wdClearNestedField'
        }))
      }));
    });
  }

}

export default TmClearNestedField;